import { filterBenefitsByTitle, findBenefitsByTitle } from '../plan/helpers';

export type Params = {
  slug: string;
  uf: string;
};

export const getPlanBeneficiary = ({ slug, uf }: Params) => {
  return findBenefitsByTitle({
    title: 'Beneficiários',
    slug,
    uf,
  });
};

export const getPlanAssistances = ({ slug, uf }: Params) => {
  return {
    eco: findBenefitsByTitle({
      title: 'Assistência descarte ecológico',
      slug,
      uf,
    }),
    auto: findBenefitsByTitle({
      title: 'Assistência auto',
      slug,
      uf,
    }),
    home: findBenefitsByTitle({
      title: 'Assistência residencial com eletro',
      slug,
      uf,
    }),
    pet: filterBenefitsByTitle({
      title: 'Assistência pet',
      slug,
      uf,
    })[0],
    grief: findBenefitsByTitle({
      title: 'Acolhimento ao luto',
      slug,
      uf,
    }),
    orthopedic: findBenefitsByTitle({
      title: 'Assistência de apoio ortopédico',
      slug,
      uf,
    }),
    teleconsultation: findBenefitsByTitle({
      title: 'Teleconsultas gratuitas',
      slug,
      uf,
    }),
    guidance: findBenefitsByTitle({
      title: 'Orientação jurídica pós-óbito',
      slug,
      uf,
    }),
  };
};

export const getPlanInsurances = ({ slug, uf }: Params) => {
  return {
    home: findBenefitsByTitle({
      title: 'Seguro residencial',
      slug,
      uf,
    }),
    mobility: findBenefitsByTitle({
      title: 'Seguro mobilidade emergencial',
      slug,
      uf,
    }),
    lender: findBenefitsByTitle({
      title: 'Seguro prestamista',
      slug,
      uf,
    }),
    accident: findBenefitsByTitle({
      title: 'Seguro de acidentes pessoais',
      slug,
      uf,
    }),
    fracture: findBenefitsByTitle({
      title: 'Seguro fratura óssea',
      slug,
      uf,
    }),
    invalid: findBenefitsByTitle({
      title: 'Seguro invalidez permanente por acidente',
      slug,
      uf,
    }),
  };
};

export const getPlanLifeBenefits = ({ slug, uf }: Params) => {
  return findBenefitsByTitle({
    title: 'Benefícios em vida',
    slug,
    uf,
  });
};

export const getPlanRules = ({ slug, uf }: Params) => {
  return findBenefitsByTitle({
    title: 'Condições para inclusão de outros dependentes.',
    slug,
    uf,
  });
};

export const getPlanFuneral = ({ slug, uf }: Params) => {
  return findBenefitsByTitle({
    title: 'Assistência funeral',
    slug,
    uf,
  });
};

export const getPlanChapel = ({ slug, uf }: Params) => {
  return (
    findBenefitsByTitle({
      title: 'Benefícios Exclusivos nas Capelas Prever Angelus',
      slug,
      uf,
    }) ||
    findBenefitsByTitle({
      title: 'Benefícios Exclusivos nas Capelas Angelus',
      slug,
      uf,
    }) ||
    findBenefitsByTitle({
      title: 'Angelus Memorial e Crematório',
      slug,
      uf,
    })
  );
};

export const getPlanCremation = ({ slug, uf }: Params) => {
  return findBenefitsByTitle({
    title: 'Assistência Sepultamento',
    slug,
    uf,
  });
};

export const getPetCremation = ({ slug, uf }: Params) => {
  return findBenefitsByTitle({
    title: 'Proteção pet',
    slug,
    uf,
  });
};
